import Notify from "@/shared/toast";

const notify = {
  install(app: any) {
    app.config.globalProperties.$notify = Notify;

    app.provide("notify", Notify);
  },
};

export default notify;
